<template>
  <div class="wjlEditor ql-editor" v-loading="wjlEditorLoading">
    <div
      :id="'wjlEditor' + onlyKey"
      :ref="'wjlEditor' + onlyKey"
      style="background: #ffffff; display: flex; flex-direction: column"
      :class="{ showBorder }"
    ></div>
  </div>
</template>

<script>
  /*
   *  这是一个富文本编译器
   *  2022.5.18
   *  author: wjl
   */
  import "./index.css";
  import wjlEditor from "./index.js";

  export default {
    name: "index.vue",
    props: {
      value: {
        // 内容
        type: String,
        default: "",
      },
      maxHeight: {
        // 编辑区域最大高度
        type: String,
        default: "400px", // '100px'
      },
      minHeight: {
        // 编辑区域最小高度
        type: String,
        default: "100px", // '100px'
      },
      height: {
        // 确定编辑区域高度
        type: String,
        default: "", // '100px'
      },
      maxLength: {
        //  文本最大长度
        type: [String, Number],
        default: "",
      },
      // 同个页面多个编译器时，数据互串，加一个唯一标识即好
      onlyKey: {
        // 页面同时有多个编译器时，要传入一个唯一标识
        type: [String, Number, Boolean],
        default: "",
      },
      showBorder: {
        type: Boolean,
        default: true, // 是否展示边框
      },
      toolMenus: {
        type: Array,
        default: () => [], // 自定义工具栏
      },
    },
    data() {
      return {
        wjlEditorLoading: false,
        wjlEditor: null,
      };
    },
    watch: {
      onlyKey() {
				if (this.wjlEditor) {
				  this.wjlEditor.txt.html(this.value == null ? "" : this.value);
				}
      },
    },
    created() {},
    mounted() {
      this.init();
      this.initHeight()
    },
    methods: {
      init() {
        this.wjlEditor = new wjlEditor("#wjlEditor" + this.onlyKey);
        if (this.toolMenus && this.toolMenus.length)
          this.wjlEditor.customConfig.menus = this.toolMenus;
        this.wjlEditor.customConfig.id = "wjlEditor" + this.onlyKey;
        this.wjlEditor.customConfig.showLinkImg = false;
        // if (this.maxLength)
        //   this.wjlEditor.customConfig.maxLength = this.maxLength;
        this.wjlEditor.customConfig.maxHeight = this.maxHeight;
        this.wjlEditor.customConfig.minHeight = this.minHeight;
        this.wjlEditor.customConfig.Height = this.height;
        // this.wjlEditor.customConfig.uploadImgMaxLength = 1; /* 限制一次最多能传几张图片 */
        this.wjlEditor.customConfig.uploadImgShowBase64 = false; // base 64 存储图片
        this.wjlEditor.customConfig.resultImgKey = "imagePath"; // 上传成功返回值url的key
        this.wjlEditor.customConfig.uploadOneEveryTime = true; //  每次上传一个图片
        this.wjlEditor.customConfig.uploadImgServer = `${process.env.UPLOAD_NAME}/file/uploadImage`; // 配置服务器端地址
        this.wjlEditor.customConfig.uploadImgHeaders = { // 自定义 header
          Authorization: "bearer " + localStorage.getItem("Authorization"),
        };
        // 截图报错处理
        this.wjlEditor.customConfig.screenshotError = (error,callback) => {
          if ((error instanceof Object) && error.type === 'screenshot' && error.code === -1) {
            return this.$showPreviewScreenshot('截图方式错误，请按照如图操作',callback)
          }
        };
        this.wjlEditor.customConfig.uploadFileName = "file"; // 后端接受上传文件的参数名
        this.wjlEditor.customConfig.uploadImgMaxSize = 20 * 1024 * 1024; // 将图片大小限制为 20M
        this.wjlEditor.customConfig.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间
        this.wjlEditor.customConfig.onchange = (html) => {
          this.$emit("input", html);
          this.$emit("change", html, JSON.parse(JSON.stringify(this.value))); // change事件。第一个是最新值，第二参数是旧值
          document.getElementById("text-elem").click();
        };

        this.wjlEditor.customConfig.onblur = (html) => {
          this.$emit("onblur", html);
        };

        this.wjlEditor.customConfig.onmaxLength = (
          length,
          keyCode,
          maxLength
        ) => {
          // console.log('-------超出--', length,  keyCode, maxLength)
          this.$message.warning("内容已超出最大长度");
        };

        this.wjlEditor.customConfig.pasteTextHandle = (content) => {
          if (content == "" && !content) return "";
          return  this.handlePaste(content)
        };
        // pasteTextHandle
        // 创建富文本编辑器
        this.wjlEditor.create();
        this.wjlEditor.txt.html(this.value);
      },
      // 处理粘贴来的多余字符
      handlePaste(str){
        this.wjlEditorLoading = true;
        str = str.replace(/<xml>[\s\S]*?<\/xml>/gi, "");
        str = str.replace(/<head>[\s\S]*?<\/head>/gi, "");
        // str = str.replace(/<a>[\s\S]*?<\/a>/gi, "");
        str = str.replace(/<o:p>[\s\S]*?<\/o:p>/gi, "");
        str = str.replace(/<colgroup>[\s\S]*?<\/colgroup>/gi, ""); // table标签里的无用标签
        str = str.replace(/<col[\s\S]*?>/gi, ""); // table标签里的无用标签
        // <col width=113 style='width:68.35pt;' span=2>

        str = str.replace(/<w:LsdException>[\s\S]*?<\/w:LsdException>/gi, "");

        str = str.replaceAll('<font face="微软雅黑" >', "");
        str = str.replaceAll('<font face="Cambria" >', "");
        str = str.replaceAll('<font face="宋体" >', "");
        str = str.replaceAll('<font face="黑体" >', "");
        str = str.replaceAll('<font face="仿宋" >', "");

        str = str.replaceAll("mso-spacerun:'yes';", "");

        str = str.replaceAll("font-family:微软雅黑;", "");
        str = str.replaceAll("font-family:Cambria;", "");
        str = str.replaceAll("font-family:黑体;", "");
        str = str.replaceAll("font-family:宋体;", "");
        str = str.replaceAll("font-family:仿宋;", "");
        str = str.replaceAll("font-family:Calibri;", "");

        str = str.replaceAll("mso-bidi-font-family:宋体;", "");
        str = str.replaceAll("mso-bidi-font-family:黑体;", "");
        str = str.replaceAll("mso-bidi-font-family:仿宋;", "");
        str = str.replaceAll("mso-font-kerning:1.0000pt;", "");

        str = str.replaceAll("mso-bidi-font-family:'Times New Roman';", "");
        str = str.replaceAll("mso-ascii-font-family:'Times New Roman';", "");
        str = str.replaceAll("mso-bidi-font-weight:normal", "");
        str = str.replaceAll('face="Times New Roman"', "");
        str = str.replaceAll("font-family:'Times New Roman';", "");
        str = str.replaceAll("mso-fareast-font-family:黑体;", "");
        str = str.replaceAll("mso-fareast-font-family:仿宋;", "");
        str = str.replaceAll(
          "mso-ascii-<br/>mso-hansi-font-size:10.0000pt;",
          ""
        );
        str = str.replaceAll(
          "mso-ascii-<br/>mso-hansi-font-size:11.0000pt;",
          ""
        );
        str = str.replaceAll(
          "mso-ascii-<br/>mso-hansi-font-size:12.0000pt;",
          ""
        );
        str = str.replaceAll(
          "mso-ascii-<br/>mso-hansi-font-size:13.0000pt;",
          ""
        );
        str = str.replaceAll("mso-font-kerning:22.0000pt;", "");
        str = str.replaceAll("mso-char-indent-count:0.0000;", "");
        str = str.replaceAll("mso-char-indent-count:1.0000;", "");
        str = str.replaceAll("mso-char-indent-count:2.0000;", "");
        str = str.replaceAll("mso-fareast-font-weight:bold;", "");
        str = str.replaceAll("mso-pagination:widow-orphan;", "");
        str = str.replaceAll("text-indent:0.0000pt;", "");
        str = str.replaceAll("text-indent:1.0000pt;", "");
        // str = str.replaceAll("text-indent:20.0000pt;", '')
        // str = str.replaceAll("text-indent:21.0000pt;", '')
        str = str.replaceAll("mso-fareast-", "");
        str = str.replaceAll("mso-hansi-", "");
        str = str.replaceAll("mso-ascii-", "");

        str = str.replaceAll("mso-ascii-mso-hansi-font-weight:bold;", "");
        str = str.replaceAll("font-size:10.0000pt;", "");
        str = str.replaceAll("font-size:10.5000pt;", "");
        str = str.replaceAll("font-size:11.0000pt;", "");
        str = str.replaceAll("font-size:12.0000pt;", "");
        str = str.replaceAll("font-size:13.0000pt;", "");
        str = str.replaceAll("font-size:14.0000pt;", "");
        str = str.replaceAll("font-size:15.0000pt;", "");
        str = str.replaceAll("font-size:16.0000pt;", "");

        str = str.replaceAll("align=center", "");

        str = str.replaceAll("page-break-before:always;", "");
        str = str.replaceAll("mso-break-type:section-break", "");

        str = str.replaceAll("color:rgb(0,0,0);", "");

        str = str.replace(/\r\n/g, "");
        str = str.replace(/\n/g, "");

        str = str.replaceAll('style=""', "");
        str = str.replaceAll('style=" "', "");
        str = str.replaceAll('style="<br>"', "");

        str = str.replaceAll("</font>", "");
        str = str.replaceAll("<font>", "");
        str = str.replaceAll('style="mso-bidi-font-weight:normal"', "");
        str = str.replaceAll("class=MsoNormal", "");
        str = str.replaceAll("class=MsoTitle", "");

        // console.log('-pasteHtml--', str)

        this.wjlEditorLoading = false;
        return str;
      },

      // 设置 编辑区域的高度
      initHeight() {
        let refwjlEditor = this.$refs['wjlEditor' + this.onlyKey];

        // 如果设置了最小高度，或者最大高度。将覆盖高度height
        if (this.height) {
          this.height.includes("px") || this.height.includes("%")
            ? (refwjlEditor.style.height = this.height)
            : (refwjlEditor.style.height = this.height + "px");
          refwjlEditor.style.maxHeight = 'none'
        }else if (this.maxHeight || this.minHeight) {

          if (this.maxHeight) {
            this.maxHeight.includes("px") || this.maxHeight.includes("%")
              ? (refwjlEditor.style.maxHeight = this.maxHeight)
              : (refwjlEditor.style.maxHeight = this.maxHeight + "px");
          }
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .wjlEditor {
    padding: 0;
    flex: 1;
    line-height: 1.5;
    h1,
    h2,
    h3,
    h4,
    h5 {
      padding: 0;
    }
  }
  /deep/ .showBorder {
    .w-e-toolbar,
    .w-e-text-container {
      border: 1px solid #ccc;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/wjlEditor/index.vue